import { PatientInfoSheetContent } from '@/modules/patientList/patientStrip/patientStripRedesigned/patientInfoSheet/PatientInfoSheetContent';
import type { Appointment } from '@/react-query/useAppointments';
import { useAppointmentsByVisitId } from '@/react-query/useAppointments';
import { useGetTasks } from '@/react-query/useGetTasks';
import { usePmsClinicalNotes } from '@/react-query/usePmsClinicalNotes';
import { useVisitSummaries } from '@/react-query/useVisitSummaries';

export const PmsInfoSheet = ({
  practiceId,
  patientId,
  apptDate,
  estimatedVisitId,
}: {
  practiceId: string;
  patientId: number;
  apptDate: Date;
  estimatedVisitId: number;
}) => {
  const { data, isLoading } = useAppointmentsByVisitId(
    estimatedVisitId,
    practiceId,
  );

  const visitId = data?.appointment?.estimatedVisitId;
  const unifiedId = data?.appointment?.unifiedId;

  const visitSummary = useVisitSummaries({
    visits: [
      {
        estimatedVisitId: visitId,
        unifiedAppointmentId: unifiedId ? Number(unifiedId) : undefined,
      },
    ],
    practiceId,
  });

  const { data: pmsClinicalNotes, isLoading: isLoadingPmsClinicalNotes } =
    usePmsClinicalNotes({
      patientId: patientId,
      apptDate: apptDate,
    });

  const { appointmentIdsToTasks, result } = useGetTasks({
    unifiedAppointmentIdsByPage: data?.appointment?.unifiedId
      ? [[data?.appointment?.unifiedId]]
      : [],
    practiceId,
  });

  const patientTask = Object.values(appointmentIdsToTasks)?.[0];

  const appointment = data && ({ ...data, lastTreatments: {} } as Appointment);

  return (
    <PatientInfoSheetContent
      appointment={appointment}
      index={0}
      visitSummary={visitSummary?.[0]?.data?.[0]}
      isInsights={true}
      patientTask={patientTask}
      pmsClinicalNotes={pmsClinicalNotes?.data}
      isLoading={
        isLoading ||
        visitSummary?.[0]?.isLoading ||
        isLoadingPmsClinicalNotes ||
        result?.[0]?.isLoading
      }
    />
  );
};
